const MINER_REWARDS_CLAIM: string = 'claim_miner_rewards';
const FILECOIN_CLAIM_IN_PROCESS: string = 'filecoin_claim_in_process';
const MOONBERG_CLAIM_IN_PROCESS: string = 'moonberg_claim_in_process';

export {
    MINER_REWARDS_CLAIM,
    FILECOIN_CLAIM_IN_PROCESS,
    MOONBERG_CLAIM_IN_PROCESS,
}
